import React, { Component } from 'react';
//var Modal = require('boron/OutlineModal');

require('../About/about.css');

class Modalviewer extends Component {

    componentDidUpdate() {
        console.log("Hello there!");
        console.log("Prop: " + this.props.modalType);
    }

    formSubmission = () => {
        console.log("Hello World!");
    }

    render() {
        switch (this.props.modalType) {
            case "chatbotoffer":
                return (
                    <div id="offer_details_div">
                        <div className="card" style={{ border: 'none', background: 'transparent' }}>
                            <h3 className="card-header">Chatbots</h3>
                            <p className="card-block" style={{ paddingTop: '10px' }}>
                                A Chatbot is basically an Artificial Intelligence that conducts a conversation using either auditory or textual methods. <br />
                                Our Chatbots are customized to fit your business's needs. <br /> <br /> Even if you do not have a business, a Tinqer Chatbot on your personal profile page would certainly get some attention!
                                We design Chatbots that can meet your needs, no matter what kind of business you are in. Some examples are Educational Chatbots, Assistant Chatbots, Marketing Chatbots, and Customer Service Chatbots.
                            </p>
                        </div>
                    </div>
                );
            case "visualoffer":
                return (
                    <div id="offer_details_div">
                        <div className="card text-center" style={{ border: 'none', background: 'transparent' }}>
                            <h3 className="card-header">Computer Vision Solutions</h3>
                            <div className="card-block" style={{ paddingTop: '10px' }}>
                                We offer Visual Recognition Software such as:
                                <li>Augmented Reality Apps</li>
                                <li>Educational Software</li>
                                <li>Image Object Recognition & Detection</li>
                                <li>Image Classification</li>
                            </div>
                        </div>
                    </div>
                );
            case "iotoffer":
                return (
                    <div id="offer_details_div">
                        <div className="card" style={{ border: 'none', background: 'transparent' }}>
                            <h3 className="card-header">Internet of Things (IOT) Solutions</h3>
                            <div className="card-block" style={{ paddingTop: '10px' }}>
                                Want to digitally transform your company with the use of Internet Of Things (IOT)? <br />
                                IoT can be used to automatically detect, troubleshoot, and/or remotely resolve any issue in your
                                application.
                                <br />
                                You can turn your business building into a smart business building, which helps reduce costs, increase employee productivity and satisfaction, and make it more efficient.
                                <br />
                                You can even connect your company vehicles to monitor its routes, increase efficiency, and anticipate vehicle maintenence.
                                <br /> Our solutions offer all this and then some!
                            </div>
                        </div>
                    </div>
                );
            case "predictionoffer":
                return (
                    <div id="offer_details_div">
                        <div className="card" style={{ border: 'none', background: 'transparent' }}>
                            <h3 className="card-header">Data Forecasting and Predictions</h3>
                            <div className="card-block" style={{ paddingTop: '10px' }}>
                                Turn your business's data into useful information that can be used to predict things necessary for a better future of the business! <br />
                                Data can be used to predict how long customers will stay loyal, who will most likely unsubscribe, which actions will lead to more profits, and much more!
                                Our solutions will take your data, create a custom AI software for it, and give you back the necessary information!
                            </div>
                        </div>
                    </div>
                );
            case "faceoffer":
                return (
                    <div id="offer_details_div">
                        <div className="card" style={{ border: 'none', background: 'transparent' }}>
                            <h3 className="card-header">Face Recognition</h3>
                            <div className="card-block" style={{ paddingTop: '10px' }}>
                                Face Recognition solutions are used for increasing security at your company, keeping track of employees, and emotional analysis.
                                Face Recognition technology has never been as advanced as it is now. With this technology, you can transform your business into something truly digital and modern!
                        </div>
                        </div>
                    </div>
                );
            case "speakeroffer":
                return (
                    <div id="offer_details_div">
                        <div className="card" style={{ border: 'none', background: 'transparent' }}>
                            <h3 className="card-header">Voice Recognition</h3>
                            <div className="card-block" style={{ paddingTop: '10px' }}>
                                Voice Recognition solutions help you analyse voice data, recognize any employee based on voice, increase security on company premises, and help increase productivity in meetings.
                                <br />
                                With voice Recognition, you can also add subtitles in meetings and/or use our AI solutions to automatically take necessary information from meetings.
                            </div>
                        </div>
                    </div>
                );
            case "NeetaRana":
                return (
                    <div id="offer_details_div">
                        <div className="card" style={{ border: 'none', background: 'transparent' }}>
                            <div className="card-block" style={{ paddingTop: '10px' }}>
                                <h3>Great! Where should we send the limited-time voucher?</h3>
                                <hr />
                                <div>
                                    <div className="form-group">
                                        <label htmlFor="exampleNameInput">Name</label>
                                        <input type="text" className="form-control" id="exampleNameInput"  placeholder="Your Name" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="exampleInputEmail">Email Address</label>
                                        <input type="email" className="form-control" id="exampleInputEmail" placeholder="Email Address" />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="examplePhoneInput">Phone</label>
                                        <input type="number" className="form-control" id="examplePhoneInput"  placeholder="123-456-7890" />
                                    </div>
                                    <button onClick={() => this.formSubmission()} className="btn btn-primary linkButton">
                                        <i className="fas fa-location-arrow"></i><span>  </span>Send
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div id="offer_details_div">
                        <div className="card" style={{ border: 'none', background: 'transparent' }}>
                            <div className="card-block" style={{ paddingTop: '10px' }}>
                                Error Getting Solution Information.... Please try again later!
                            </div>
                        </div>
                    </div>
                );
        }
    }
}

export default Modalviewer;


// WEBPACK FOOTER //
// ./src/Modals/Modalviewer.js